import React from 'react';
import { useSelector } from 'react-redux';
import { Card } from 'react-bootstrap';
import { getUser } from '../../reducers/selectors';
import WorklistNodesTable from './WorklistNodesTable';
import WorklistScriptsMappings from './WorklistScriptsMappings';

function WorklistPage() {
  const user = useSelector(getUser);

  return (
    <div>
      <Card className="page-panel-common">
        <Card.Body>
          <h3>Worklist</h3>
          <div id="worklist-page-body">
            <WorklistNodesTable user={user} />
            <WorklistScriptsMappings user={user} />
          </div>
        </Card.Body>
      </Card>
    </div>
  );
}

export default WorklistPage;
